import styled from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';
import { ResidenceSpecialOfferTypeEnum } from '../../../../graphql/graphql';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const AdditionalInfoContainer = styled(FlexColumn)`
  gap: 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding-bottom: 30px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  }
`;

export const AdditionalInfoItem = styled(FlexibleDiv)<{
  $offerType: ResidenceSpecialOfferTypeEnum;
}>`
  align-items: center;
  gap: 20px;

  &::before {
    content: '';
    flex-shrink: 0;
    width: 26px;
    height: 30px;
    background: url('/static/images/residences/${({ $offerType }) =>
        $offerType.toLowerCase()}.svg')
      no-repeat center;
    background-size: contain;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 15px;
  }
`;

export const InfoContainer = styled(FlexColumn)`
  gap: 5px;
`;

export const InfoDescription = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
